import { useTranslation } from 'react-i18next';
import { Crown } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

interface UpgradePromptProps {
  plan?: 'premium' | 'duo';
  message?: string;
  compact?: boolean;
}

export default function UpgradePrompt({ plan = 'premium', message, compact = false }: UpgradePromptProps) {
  const { t } = useTranslation('subscription');
  const navigate = useNavigate();

  if (compact) {
    return (
      <button
        onClick={() => navigate('/dashboard/abonnement')}
        className="flex items-center gap-1.5 text-sm text-primary-600 hover:text-primary-700 transition-colors"
      >
        <Crown className="w-4 h-4" />
        <span>{message || t('limits.upgradeForMore')}</span>
      </button>
    );
  }

  return (
    <div className="flex flex-col items-center gap-3 p-6 rounded-xl border border-primary-200 bg-primary-50/50">
      <Crown className="w-8 h-8 text-primary-500" />
      <p className="text-sm text-gray-600 text-center">
        {message || t('limits.upgradeMessage', { plan: t(`plans.${plan}`) })}
      </p>
      <button
        onClick={() => navigate('/dashboard/abonnement')}
        className="btn-primary btn-sm"
      >
        {t('actions.upgrade', { plan: t(`plans.${plan}`) })}
      </button>
    </div>
  );
}
